module.exports = __webpack_public_path__ + "img/pe.d47398da.svg";